import Vue from 'vue'

// Global Components
import PageBuilder from '../components/PageBuilder/PageBuilder'
import PageBuilderPart from '../components/PageBuilderPart/PageBuilderPart'

let load = file => {
  return () => System.import('../components/' + file)
}

Vue.component('app-header', load('Header/Header'))
Vue.component('app-footer', load('Footer/Footer'))
Vue.component('app-signup', load('Signup/Signup'))
Vue.component('page-builder', PageBuilder)
Vue.component('page-builder-part', PageBuilderPart)
Vue.component('project-intro', load('Pages/Projects/Rows/Intro'))
Vue.component('large-image', load('Pages/Projects/Rows/LargeImage'))
Vue.component('two-column', load('Pages/Projects/Rows/TwoColumn'))
Vue.component('stacked-column', load('Pages/Projects/Rows/StackedColumn'))
Vue.component('project-quote', load('Pages/Projects/Rows/Quote'))
Vue.component('project-content', load('Pages/Projects/Rows/Contact'))
Vue.component('video-block', load('Pages/Projects/Rows/video'))
Vue.component('image-carousel', load('Pages/Projects/Rows/Carousel'))
Vue.component('instagram', load('Instagram/Instagram'))
Vue.component('loading', load('Loading/Loading'))




// WEBPACK FOOTER //
// ./src/imports/components.js